import React, { FC } from 'react'

import { EventTicket } from '@saasalerts/common/shared'
import {
  Tooltip,
  Modal,
  Heading,
  Button,
  ButtonType,
  Text,
  Icon,
} from '@saasalerts/ui'
import { getLocalDateTime } from '@/utils/methods'
import {
  faSquareArrowUpRight,
  faInfoCircle,
} from '@awesome.me/kit-e270131d0a/icons/classic/solid'

export const Tickets: FC<
  React.PropsWithChildren<{
    open: boolean
    setOpen: (open: boolean) => void
    tickets: EventTicket[]
  }>
> = ({ open, setOpen, tickets }) => {
  return (
    <Modal open={open} setOpen={setOpen}>
      <Modal.Header>
        <Modal.TitleBar>
          <Heading type="h2">Tickets</Heading>
        </Modal.TitleBar>
      </Modal.Header>
      <Modal.Body>
        <div className="flex flex-col space-y-4">
          {tickets.map((ticket, index) => {
            const { type, link, ticketNumber, emails } = ticket
            const mails = emails?.map((email: string) => email).join(', ')
            return (
              <div key={index}>
                <div className="flex items-center gap-2">
                  {link && (
                    <Button
                      kind={ButtonType.SOLID_BRAND_LINK}
                      onClick={() =>
                        window.open(link, '_blank', 'noopener,noreferrer')
                      }
                      iconPosition="right"
                      Icon={faSquareArrowUpRight}
                      className="!h-auto"
                    >
                      {type}
                      <Text
                        as="span"
                        weight="medium"
                        color="inherit"
                        className="pl-1"
                      >
                        {ticketNumber}
                      </Text>
                    </Button>
                  )}

                  {emails && emails.length > 0 && (
                    <Tooltip
                      placement="right-start"
                      maxWidth={260}
                      content={
                        <Text color="white" size="sm">
                          {mails}
                        </Text>
                      }
                    >
                      <Text
                        weight="medium"
                        className="flex items-center gap-x-1"
                      >
                        {type}
                        <Text as="span">{ticketNumber}</Text>
                        <Icon size="1x" color="inherit" icon={faInfoCircle} />
                      </Text>
                    </Tooltip>
                  )}
                </div>
                <Text size="sm" color="secondary">
                  {getLocalDateTime(ticket.time)}
                </Text>
              </div>
            )
          })}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          kind={ButtonType.OUTLINE_WHITE}
          onClick={() => {
            setOpen(false)
          }}
        >
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
